<script lang="ts">
	import { getMarketplaceSeoContent, type MarketplaceSeoKey } from '$lib/content/marketplace-seo';
	import type { FeaturedReview } from '@/routes/barcos/[...segments]/+page';
	import { getLocale } from '@/paraglide/runtime';
	import MarketplaceFaqSection from './MarketplaceFaqSection.svelte';
	import MarketplaceGuideSection from './MarketplaceGuideSection.svelte';
	import MarketplaceReviewsSection from './MarketplaceReviewsSection.svelte';

	interface Props {
		seoKey: MarketplaceSeoKey;
		featuredReviews: FeaturedReview[];
	}

	let { seoKey, featuredReviews }: Props = $props();

	const locale = $derived(getLocale());
	const content = $derived.by(() => {
		void locale;
		return getMarketplaceSeoContent(seoKey);
	});
</script>

<div class="border-t bg-muted/30">
	<div class="mx-auto max-w-5xl space-y-12 px-4 py-10 md:space-y-14 md:py-14 lg:px-8">
		<MarketplaceReviewsSection
			title={content.reviewsTitle}
			subtitle={content.reviewsSubtitle}
			reviews={featuredReviews}
		/>

		<MarketplaceGuideSection sections={content.guideSections} />

		<MarketplaceFaqSection title={content.faqTitle} faqs={content.faqs} />
	</div>
</div>
